import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const LandingPart5 = ({part, contact}) => { 
    return (
        <div ref={part} className="landing-part part-5">
          <div className="l-row">
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
          </div>
          <div className="l-row">
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
          </div>
           <div className="l-row">
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
          </div>
           <div className="l-row">
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
            <img src="/sp404.svg"/>
          </div>
          <div className="overlay-text">
            what dreams will you create?
          </div>
          {contact}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPart5);
